<template>
  <v-container >
    <v-row>
      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการข้อมูลทำเนียบคณบดี : </p>
            <span v-if="this.direct_dean_list_type=='T1'"> ประวัติการทำงาน</span>
            <span v-else-if="this.direct_dean_list_type=='T2'"> รางวัลและเกียรติที่ได้รับ</span>
            <span v-else> เครื่องราชอิสริยาภรณ์</span>
            <span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + web_con_direct_dean_lists.length }} รายการ) </span>
            <v-spacer></v-spacer>

          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :options="options"
                :items="web_con_direct_dean_lists"
                sort-by="order_seq">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>
                </template>


              </template>





              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>

              </template>


              <template v-slot:item.api="{ item }">
                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>
                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }} : <span v-if="this.direct_dean_list_type=='T1'"> ประวัติการทำงาน</span>
              <span v-else-if="this.direct_dean_list_type=='T2'"> รางวัลและเกียรติที่ได้รับ</span>
              <span v-else> เครื่องราชอิสริยาภรณ์</span> </p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="3">
                  <v-text-field
                      v-model="editForm.order_seq"
                      label="ลำดับ"
                      required
                      disabled
                      v-if="state=='addForm'"
                  ></v-text-field>

                  <v-text-field
                      v-model="editForm.order_seq"
                      :rules="editForm.textReqRules.concat(editForm.orderRules)"
                      label="ลำดับ"
                      required
                      v-else
                  ></v-text-field>

                </v-col>


              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                      v-model="editForm.direct_dean_list_title_th"
                      :rules="editForm.textReqRules"
                      label="รายการ/รายละเอียด (TH)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                      v-model="editForm.direct_dean_list_title_en"
                      :rules="editForm.textReqRules"
                      label="รายการ/รายละเอียด (EN)"
                      required
                  ></v-text-field>
                </v-col>


              </v-row>


              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="12">
                  <v-switch
                      v-model="editForm.active"
                      inset
                      color="success"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ใช้งาน"
                      required
                  ></v-switch>
                </v-col>

              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';


export default {
  name: 'EduLevelManagement',
  data() {
    return {
      state: 'index',
      snackbar: null,
      search: '',
      selected: [],
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          value: 'order_seq',
        },
        {text: 'รายการ', value: 'direct_dean_list_title_th'},

        {text: 'ใช้งาน', value: 'active'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],
      options: {
        sortBy: ['order_seq'],
        sortDesc: [true]
      },

      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {
        valid: true,
        direct_dean_list_id: '',
        codeRules: validateRules.codeRules,
        textReqRules: validateRules.textReqRules,
        numRules: validateRules.numRules,
        orderRules: validateRules.orderRules,
        direct_dean_list_title_th: '',
        direct_dean_list_title_en: '',
        direct_dean_list_type:'',
        user_name:'',
        active: 'N',
        order_seq: 'AUTO',
      },

    }
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('web_con_direct_dean_lists', ['direct_dean_list_type','user_name','web_con_direct_dean_lists', "isReceiving", "isDeleting", "idToDelete", "web_con_dean_listMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },

  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    web_con_dean_listMessage() {

      if (this.web_con_dean_listMessage !== '') {
        this.notification = this.web_con_dean_listMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    }
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.setWeb_Con_Direct_Dean_ListsRequest();
    this.getWeb_Con_Direct_Dean_ListsRequest();


  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('web_con_direct_dean_lists',
        [
          "setWeb_Con_Direct_Dean_ListsRequest",
          "getWeb_Con_Direct_Dean_ListsRequest",
          "deleteWeb_Con_Direct_Dean_ListRequest",
          "updateWeb_Con_Direct_Dean_ListRequest",
          "createWeb_Con_Direct_Dean_ListRequest"
        ]
    ),


    addItem() {

      this.editedIndex = -1 //index = -1 add
      this.editForm.direct_dean_list_id = null;
      this.editForm.direct_dean_list_type = this.direct_dean_list_type;
      this.editForm.user_name = this.user_name.user_name;
      this.editForm.order_seq = 'AUTO';
      this.editForm.direct_dean_list_title_th = null;
      this.editForm.direct_dean_list_title_en = null;
      this.editForm.active = 'Y';
      this.state = 'addForm';

    },
    editItem(item) {
      this.editedIndex = this.web_con_direct_dean_lists.indexOf(item) //index ของ row ที่จะแก้ไข
      this.editForm.direct_dean_list_id = item.direct_dean_list_id;
      this.editForm.user_name = this.user_name.user_name;
      this.editForm.direct_dean_list_type = item.direct_dean_list_type;
      this.editForm.direct_dean_list_title_th = item.direct_dean_list_title_th;
      this.editForm.direct_dean_list_title_en = item.direct_dean_list_title_en;
      this.editForm.order_seq = item.order_seq;
      this.editForm.active = item.active;
      // this.editForm = Object.assign({}, item) //ถ้าใช้ validate not work!!
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteWeb_Con_Direct_Dean_ListRequest({direct_dean_list_id: item.direct_dean_list_id})


    },
    close() {

      if (this.errorMessage == false || this.web_con_dean_listMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }

    },
    save() {

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.web_con_direct_dean_lists[this.editedIndex], this.editForm)
            :
            this.updateWeb_Con_Direct_Dean_ListRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.web_con_direct_dean_lists.push(this.editForm)
            :
            this.createWeb_Con_Direct_Dean_ListRequest(this.editForm)
      }

    },

    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },

    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },

    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    reset() {
      this.$refs.form.reset()
    },

    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },



  },
}
</script>

<style src="./ConDirectDeanListManagement.scss" lang="scss"/>
